import React, { useState, Component } from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { HeroV2 } from './components/HeroV2';
import { TrustedBy } from './components/TrustedBy';
import { Features } from './components/Features';
import { ProductShowcase } from './components/ProductShowcase';
import { Stats } from './components/Stats';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
import { CoffeeTraceability } from './pages/CoffeeTraceability';
import { CookstoveCredits } from './pages/CookstoveCredits';
import { ForestryREDD } from './pages/ForestryREDD';
import { Agroforestry } from './pages/Agroforestry';
import { RenewableEnergy } from './pages/RenewableEnergy';
import { About } from './pages/About';
const dmrvPages: Record<string, ComponentType> = {
  coffee: CoffeeTraceability,
  cookstoves: CookstoveCredits,
  forestry: ForestryREDD,
  agroforestry: Agroforestry,
  energy: RenewableEnergy,
  about: About
};
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  const handleNavigate = (page: string) => {
    setCurrentPage(page);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  const DMRVPage = dmrvPages[currentPage];
  return <div className="w-full min-h-screen bg-[#FAFDF7]" data-id="element-0">
      <Navbar currentPage={currentPage} onNavigate={handleNavigate} data-id="element-1" />
      {DMRVPage ? <DMRVPage data-id="element-2" /> : <>
          <HeroV2 data-id="element-3" />
          <TrustedBy data-id="element-4" />
          <Features data-id="element-5" />
          <ProductShowcase data-id="element-6" />
          <Stats data-id="element-7" />
          <CTASection data-id="element-8" />
          <Footer data-id="element-9" />
        </>}
    </div>;
}